import * as bootstrap from 'bootstrap'
import $ from 'jquery'

/**
 * De views in deze applicatie zijn geschreven voor Bootstrap 4 (`data-toggle`,
 * `data-target`, `data-dismiss`), maar de bundle is Bootstrap 5 — en die luistert
 * alleen naar `data-bs-*`. Daardoor deed elke knop met `data-toggle="modal"` of
 * `data-toggle="collapse"` helemaal niets, zonder enige foutmelding: geen popup,
 * geen uitklappende rij. Bootstrap 5 heeft bovendien de jQuery-plugins geschrapt,
 * dus `$('#x').modal('show')` bestond ook niet meer.
 *
 * Deze laag vertaalt het oude schrijfwijze naar het nieuwe, in plaats van 70
 * bestanden aan views te herschrijven. Zodra een view naar `data-bs-*` gaat blijft
 * hij gewoon werken — er wordt alleen bijgezet, nooit overschreven.
 */

// Alleen wat Bootstrap 5 kent. `buttons` en `validator` zijn geen Bootstrap 5-onderdelen.
const BEKENDE_TOGGLES = ['modal', 'collapse', 'dropdown', 'tab', 'pill', 'offcanvas', 'tooltip', 'popover']

function vertaal(wortel = document) {
    wortel.querySelectorAll('[data-toggle]:not([data-bs-toggle])').forEach((el) => {
        const soort = el.getAttribute('data-toggle')

        if (! BEKENDE_TOGGLES.includes(soort)) {
            return
        }

        el.setAttribute('data-bs-toggle', soort)

        // `data-target` alleen meenemen bij een toggle die we herkennen; hetzelfde
        // attribuut wordt elders in de code voor heel andere dingen gebruikt.
        for (const [oud, nieuw] of [['data-target', 'data-bs-target'], ['data-parent', 'data-bs-parent']]) {
            if (el.hasAttribute(oud) && ! el.hasAttribute(nieuw)) {
                el.setAttribute(nieuw, el.getAttribute(oud))
            }
        }
    })

    wortel.querySelectorAll('[data-dismiss]:not([data-bs-dismiss])').forEach((el) => {
        el.setAttribute('data-bs-dismiss', el.getAttribute('data-dismiss'))
    })

    // Tooltips en popovers starten in Bootstrap 5 niet meer vanzelf.
    wortel.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => bootstrap.Tooltip.getOrCreateInstance(el))
    wortel.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => bootstrap.Popover.getOrCreateInstance(el))
}

/**
 * Geef de jQuery-plugins terug die Bootstrap 5 heeft geschrapt, zodat bestaande
 * aanroepen als `$('#modal').modal('show')` en `.modal('hide')` blijven werken.
 */
function herstelJqueryPlugins() {
    const componenten = {
        modal: bootstrap.Modal,
        collapse: bootstrap.Collapse,
        dropdown: bootstrap.Dropdown,
        tab: bootstrap.Tab,
        offcanvas: bootstrap.Offcanvas,
        tooltip: bootstrap.Tooltip,
        popover: bootstrap.Popover,
    }

    for (const [naam, Component] of Object.entries(componenten)) {
        $.fn[naam] = function (actie, ...rest) {
            return this.each(function () {
                // Een object of niets betekent "maak aan met deze opties".
                const instantie = typeof actie === 'object' || actie === undefined
                    ? Component.getOrCreateInstance(this, actie || {})
                    : Component.getOrCreateInstance(this)

                if (typeof actie === 'string' && typeof instantie[actie] === 'function') {
                    instantie[actie](...rest)
                }
            })
        }
    }
}

herstelJqueryPlugins()

document.addEventListener('DOMContentLoaded', () => {
    vertaal()

    // Schermen die hun inhoud via ajax bijladen zouden anders opnieuw dode knoppen krijgen.
    new MutationObserver((mutaties) => {
        for (const mutatie of mutaties) {
            for (const knoop of mutatie.addedNodes) {
                if (knoop.nodeType === 1) {
                    vertaal(knoop)
                }
            }
        }
    }).observe(document.body, { childList: true, subtree: true })
})

export { vertaal }
